import * as React from 'react';

const ScrollAreaViewportContext = React.createContext<HTMLDivElement | null>(null);

function useScrollAreaViewport() {
	return React.useContext(ScrollAreaViewportContext);
}

export { ScrollAreaViewportContext, useScrollAreaViewport };
